export default __webpack_public_path__ + "static/media/home_1stSec.00c0119a.png";